import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';
import { Dropdown } from 'react-bootstrap';

import {
  GlobalManufacturerHarvestStatus,
  GlobalManufacturerHarvestStatusLabels,
} from 'lib/enums/GlobalManufacturerHarvestStatus';
import { lightTransparentBlue } from 'lib/css/colors';

function StatusDropdown({ currentStatus, onStatusSelect, recordId }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = status => {
    setIsOpen(false);
    onStatusSelect(status);
  };

  const displayText = currentStatus
    ? GlobalManufacturerHarvestStatusLabels[currentStatus]
    : 'Select Status';

  const dropdownId = `status-dropdown-${recordId}`;

  return (
    <Dropdown show={isOpen} onToggle={setIsOpen}>
      <Dropdown.Toggle variant="link" className={css(styles.dropdownToggle)} id={dropdownId}>
        {displayText}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {Object.values(GlobalManufacturerHarvestStatus).map(status => (
          <Dropdown.Item
            key={status}
            onClick={() => handleSelect(status)}
            active={currentStatus === status}
          >
            {GlobalManufacturerHarvestStatusLabels[status]}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

const styles = StyleSheet.create({
  dropdownToggle: {
    padding: '0.25rem 0.5rem',
    textDecoration: 'none',
    color: lightTransparentBlue,
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline',
    },
  },
});

StatusDropdown.propTypes = {
  currentStatus: PropTypes.string,
  onStatusSelect: PropTypes.func.isRequired,
  recordId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

StatusDropdown.defaultProps = {
  currentStatus: null,
};

export default StatusDropdown;
